import { ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'
import Box from '@/common/components/Box'

export const ColumnHeader = ({ icon: Icon, title }: { icon: LucideIcon; title: string }) => (
  <div className="flex items-center gap-2 border-b border-white-200 pb-2">
    <Icon className="size-5 text-white-400" strokeWidth={1.5} />
    <h2 className="text-base font-bold text-white-800">{title}</h2>
  </div>
)

export const Section = ({ title, children }: { title: string; children: ReactNode }) => (
  <Box className="p-4 flex flex-col gap-3">
    <p className="text-sm font-medium">{title}</p>
    {children}
  </Box>
)

export const TextBlock = ({ value, emptyLabel }: { value?: string | null; emptyLabel: string }) =>
  value ? (
    <p className="text-sm text-white-800 whitespace-pre-line">{value}</p>
  ) : (
    <p className="text-xs italic text-white-300">{emptyLabel}</p>
  )
